"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
var Tooltip = function Tooltip(props) {
  var children = props.children,
    text = props.text;
  var _useState = (0, _react.useState)(false),
    isActive = _useState[0],
    setActive = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    tooltipDisplayed = _useState2[0],
    setTooltipDisplayed = _useState2[1];
  var closeTooltip = function closeTooltip() {
    setTooltipDisplayed(true);
    setActive(false);
  };
  (0, _react.useEffect)(function () {
    var close = isActive && !tooltipDisplayed && setTimeout(function () {
      closeTooltip();
    }, 3000);
    return function () {
      clearInterval(close);
    };
  }, [isActive]);
  return tooltipDisplayed ? __jsx(_Box["default"], null, children) : __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 1,
      cursor: tooltipDisplayed ? "auto" : "pointer"
    },
    onClick: function onClick() {
      return setActive(true);
    }
  }, isActive && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      zIndex: 2,
      font: "xs",
      color: "white",
      borderRadius: 5,
      p: "s5",
      backgroundColor: "active",
      top: "110%",
      minWidth: ["100px", null, null, "200px"],
      left: ["-90px", null, null, "-168px"]
    },
    onClick: function onClick() {
      return closeTooltip();
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      position: "absolute",
      bottom: "100%",
      right: "10%",
      ml: "-5px",
      borderWidth: "5px",
      borderStyle: "solid",
      borderLeftColor: "transparent",
      borderRightColor: "transparent",
      borderBottomColor: "active",
      borderTopColor: "transparent"
    }
  }), text), __jsx(_Box["default"], {
    sx: {
      position: "relative",
      zIndex: 100
    }
  }, children));
};
var _default = Tooltip;
exports["default"] = _default;